export interface SimpleResourceItem {
  id: number;
  str: string;
}

export class ResourceItem {
  id?: number;
  str?: string;

  constructor(data?: any) {
    if (data) {
      this.id = data.id;
      this.str = data.str;
    }
  }

  toString(): string {
    if (this.str) return this.str;
    return "Unknown resource item" + (this.id ? this.id.toString() : "");
  }

  getPostData(): any {
    return {};
  }

  getDiff(other: this): ItemDiff<this> {
    throw "not implemented";
  }
}

export type ItemDiff<T = any> = { [key: string]: boolean | ItemDiff };

export interface IncompleteResourceItem {
  id: number;
  str: string;

  [key: string]: any;
}

export const getItemReferencePostData = (item: IncompleteResourceItem | null) =>
  item ? { id: item.id! } : null;
